// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var CustomerDetailsController = function ($scope, $routeParams, Customer, Contract, LedgerEntry, Invoice, InvoiceDraft, Dunning, LedgerEscalation, $http, Entity, PrepaidCard, Webhook) {
    $scope.selectedContractId = null;
    $scope.transactionsBaseUrl = window.location.origin + "/#/payments";
    $scope.entityId = $routeParams.entityId;
    $scope.selectedTab = $routeParams.selectedTab;
    $scope.customer = Customer.get({ entityId: $routeParams.entityId, customerId: $routeParams.customerId });
    $scope.subscriptions = Contract.query({ entityId: $routeParams.entityId, customerId: $routeParams.customerId });
    $scope.subscriptions.$promise.then(function(result) {
        $scope.allContractIds = [];
        let subscriptions = result;
        for (let i = 0; i < subscriptions.length; i++) {
            let item = subscriptions[i];            
            $scope.allContractIds.push({ Id : item.Contract.Id, ReferenceCode : item.LedgerInfo.ReferenceCode });
        }
    });    
    $scope.ledgerEntries = $scope.paginator(function(options, callback) {
        return LedgerEntry.query(options, function() { callback(); });
    }, { entityId: $routeParams.entityId, customerId: $routeParams.customerId }, 500);

    setCustomerIdQueryParam();
    $scope.hooksfilter = {};

    $scope.loadWebhooks = function () {
        $scope.hooks = $scope.paginator(function (options, callback) {
                return Webhook.query(options, function () { callback(); });
            },
            {
                entityIdFilter: $routeParams.entityId,
                customerIdFilter: $routeParams.customerId,
                hookEvent: $scope.hooksfilter.type,
                status: $scope.hooksfilter.status
            }, 100);
    }

    $scope.loadWebhooks();

    $scope.onContractChange = function() {
        setCustomerIdQueryParam();
    }

    $scope.invoiceDrafts = InvoiceDraft.query({ customerId: $routeParams.customerId });
    $scope.invoices = Invoice.query({ customerId: $routeParams.customerId });
    $scope.dunnings = Dunning.query({ entityId: $routeParams.entityId, customerId: $routeParams.customerId });
    $scope.escalations = LedgerEscalation.get({ entityId: $routeParams.entityId, customerId: $routeParams.customerId });
    
    $scope.loadAssignments = function(id) {
        $http.get(`/api/v1/entities/${$routeParams.entityId}/contracts/${id}/assignments`).then(function(result) {
            $scope.subscriptions.find(x => x.Contract.Id === id).Assignments = result.data;
        });
    }
    
    $scope.getDunningsByContract = function(contractId) {
        if (!contractId || contractId === "" || !$scope.subscriptions)
            return $scope.dunnings;

        return $scope.dunnings.filter(item => item.Dunning.ContractId === contractId);
    };

    $scope.getHooksByContract = function(contractId) {
        const contractIdLambda = (item) => item.Data.ContractId;
        return $scope.getFilteredByContractId($scope.hooks.items, contractId,  contractIdLambda);
    };
    
    $scope.getEscalationsByContract = function(contractId) {
        const contractIdLambda = (item) => item.LedgerEscalation.ContractId.Untyped;
        return $scope.getFilteredByContractId($scope.escalations.LedgerEscalations, contractId,  contractIdLambda);
    };

    $scope.getSubscriptionsByContract = function(contractId) {
        const contractIdLambda = (item) => item.Contract.Id;
        return $scope.getFilteredByContractId($scope.subscriptions, contractId, contractIdLambda);
    };

    $scope.getContractFilter = function(list, contractId) {
        const contractIdLambda = (item) => item.ContractId;
        return $scope.getFilteredByContractId(list, contractId,  contractIdLambda);
    }; 

    $scope.getFilteredByContractId = function(list, id,  getContractId) {
        if (!id || id === "" || !list)
            return list;

        return list.filter(item => getContractId(item) === id);
    };

    $http.get("/api/v1/entities/" + $routeParams.entityId + "/customers/" + $routeParams.customerId + "/ledgerEntriesCount")
        .then(function(result) { $scope.ledgerEntriesCount = result.data; });

    $scope.entityDetails = Entity.get({entityId: $routeParams.entityId}, function (data) {
        $scope.entity = data.Entity;
        $scope.entityFeatures = data.Features;
    });

    $scope.prepaidCards = PrepaidCard.query({
        customerId : $routeParams.customerId,
        entityId: $routeParams.entityId
    });

    $scope.isPrepaidCardTabShown = function() {
        return $scope.entityFeatures && $scope.entityFeatures.includes("Epay");
    }

    $scope.isAnyPrepaidCardExists = function() {
        return $scope.prepaidCards && $scope.prepaidCards.length > 0;
    }

    function setCustomerIdQueryParam() {
        let url = new URL($scope.transactionsBaseUrl);
        let contracts  = $scope.allContractIds ?  $scope.allContractIds.filter(x => x.Id === $scope.selectedContractId) : [];

        if (contracts.length === 1) {
            url.searchParams.append('contractId', $scope.selectedContractId);
            $scope.transactionQueryParams = "&contractId=" + $scope.selectedContractId;
        }
        else if ($routeParams.customerId)
            url.searchParams.append('customerId', $routeParams.customerId);

        $scope.transactionsUrl = $scope.transactionsBaseUrl + url.search;
    }
};
CustomerDetailsController.$inject = ['$scope', '$routeParams', 'Customer', 'Contract', 'LedgerEntry', 'Invoice', 'InvoiceDraft', 'Dunning', 'LedgerEscalation', '$http', 'Entity', 'PrepaidCard', 'Webhook'];
